import { isSSR } from '@k2/core/util'
import type { NavigationGuardWithThis, RouteLocationRaw } from 'vue-router'
import { useOrganizationStore } from '@/layout/store'
import { organizationEntryRedirect, organizationRouteNeedsRead } from './organization-route-rules'

export const organizationRoutingGuard: NavigationGuardWithThis<undefined> = async (to, from) => {
  if (isSSR || !organizationRouteNeedsRead(to, from)) return true

  const organizationId = to.params.organizationId
  if (typeof organizationId !== 'string') return true

  const result = await useOrganizationStore().refreshDetails(organizationId)
  if (result.status === 404) return { name: 'organizations' } as RouteLocationRaw
  if (result.error) throw result.error
  if (!result.data) throw new Error('organization details request returned no data')

  const destination = organizationEntryRedirect(to, result.data.hasBrands, result.data.rights.includes('brand.write'))
  if (!destination) return true

  return { name: destination, params: { organizationId } } as RouteLocationRaw
}
